import { User } from '@front/common/src/types/commons';
import { userMetaData } from '@front/common/src/utils/intercom';
import { errorNotifier } from '@front/common/src/errors/error-notifier';

const updateIntercomUser = (user: User) => {
  window.Intercom('update', userMetaData(user));
};

export const connectUserToExternalSystems = (user: User) => {
  updateIntercomUser(user);
  errorNotifier.setUser(user);
};
